<div class="kt-portlet">
    <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
                Başvuru Listem
            </h3>
        </div>
    </div>
    <div class="kt-portlet__body">
        <div class="kt-section">
            <div class="kt-section__content">

                <div class="kt-pagination  kt-pagination--brand">
                    <ul class="kt-pagination__links">
                    </ul>
                </div>
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Etkinlik adı</th>
                                <th>Başvurulan pozisyon</th>
                                <th>Başvuru tarihi</th>
                                <th>Başvuru durumu</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let application of applicationList; index as i;">
                                <td>{{i+1}}</td>
                                <td>{{application.eventName}}</td>
                                <td>{{application.roleName}}</td>
                                <td>{{application.applicationDate}}</td>
                                <td>{{getApplicationStatus(application.status)}}</td>
                            </tr>
                            <tr *ngIf="applicationList.length == 0">
                                <td colspan="5" style="text-align: center;">Aktif başvurun bulunmuyor.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>